module.exports = __webpack_public_path__ + "img/acaki14.7a906d08.jpg";